import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../translations';
import { ReceptionServiceFormController } from '../ReceptionServiceForm';

export type ReceptionServiceAdditionalInformationValue = string;

type ReceptionServiceAdditionalInformationTextareaProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServiceAdditionalInformationTextarea = (
   props: ReceptionServiceAdditionalInformationTextareaProps
): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: false,
         maxLength: 1000,
      };
   }, []);

   return (
      <Textarea
         controller={props.register('additionalInformation', validationRules)}
         rows={3}
         maxRows={5}
         maxLength={1000}
         label={receptionServiceTranslationKeys.shared.form.components.additionalInformationTextarea.label}
         placeholder={receptionServiceTranslationKeys.shared.form.components.additionalInformationTextarea.placeholder}
         testId={'additionalInformation'}
         disabled={props.disabled}
         defaultValue={null}
      />
   );
};
